import * as React from 'react';
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { Modal } from "../../../../Modal";
import {WebDate} from "../../../../WebDate";
export const Screen1 = ({ widget, id }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.container}>
          <div className={screen1.info}>
            <div className={screen1.timeWrap}>
              <time><WebDate id={id}/></time>
              <span className={screen1.type}>Бесплатный&nbsp;мастер-класс</span>
            </div>
            <h1>Как легко учиться<br/> в&nbsp;школе по&nbsp;всем<br/> предметам</h1>
            <p className={screen1.desc}>Секреты обучения от эксперта, который&nbsp;был двоечником, но&nbsp;смог&nbsp;закончить школу в&nbsp;14&nbsp;лет, вуз&nbsp;в&nbsp;20, а&nbsp;в&nbsp;21&nbsp;уже создал свой бизнес</p>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться бесплатно</button>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
